import { useEffect, useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
//Components
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
import FilterTable from "../../components/Filter/FilterTable";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import Delete from "../../components/Modals/Delete";
import Details from "../../components/Modals/Frame/Details";
import Update from "../../components/Modals/Frame/Update";
import NoData from "../../components/NoData";
import PopMenu from "../../components/PopMenuTable";
import TitleMenu from "../../components/Title/TitleMenu";
import TopActionBar from "../../components/TopActionBar";
//hooks
import { useCheckbox } from "../../hooks/useCheckbox";
import useLoading from "../../hooks/useLoading";
import { useMultipleModal } from "../../hooks/useMultipleModal";
//utils
import { CurrencyFormat } from "utils/CurrencyFormat";
//Icons
import { List, PencilSimple, Trash } from "@phosphor-icons/react";
import { FiMoreVertical } from "react-icons/fi";
//Interfaces
import { IFrame } from "Interfaces/IFrame";
import { IPage } from "Interfaces/IPage";

export default function FrameGlasses() {
  const [frame, setFrame] = useState<IFrame[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [selectAll, setSelectAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0
  });

  // Para um array de objetos
  const [tags, setTags] = useState<Array<{
    barcode: string;
    code: string;
    brands: string;
    price: string;
  }>>([]);

  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } = useCheckbox();
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();

  const titleListPopMenu = ["Armação", "Fornecedor", "Grife", "Tipo de Armação"];
  const titlePopButtton = ["create", "supplier", "brainds", "material"];

  const [headerTable, setHeaderTable] = useState([
    { name: '#', filter: false },
    { name: 'Código', filter: false },
    { name: 'Tam', filter: true, data: [], url: 'size', api: 'tamanho', activeFilter: false },
    { name: 'Ponte', filter: true, data: [], url: 'bridge', api: 'ponte', activeFilter: false },
    { name: 'Haste', filter: true, data: [], url: 'haste', api: 'haste', activeFilter: false },
    { name: 'Grife', filter: true, data: [], url: 'brands.brand', api: 'grife', activeFilter: false },
    { name: 'Tipo', filter: true, data: [], url: 'materials.material', api: 'material', activeFilter: false },
    { name: 'Cor', filter: true, data: [], url: 'color', api: 'cor' },
    { name: 'Qtd.', filter: false },
    { name: 'Valor R$', filter: false },
    { name: 'Ações', filter: false },
  ]);

  const menuItemsPop = [
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const [filters, setFilters] = useState({
    tamanho: "",
    haste: "",
    ponte: "",
    cor: "",
    grife: "",
    material: "",
  });

  const extractFilterData = (apiData: IFrame[]) => {
    const updatedHeaderTable = headerTable.map(header => {
      if (header.filter && header.url) {
        // Verifica se a URL contém um ponto (indicando propriedade aninhada)
        if (header.url.includes('.')) {
          const [parentProp, childProp] = header.url.split('.');

          // Extrai valores únicos das propriedades aninhadas
          const uniqueValues = Array.from(
            new Set(
              apiData
                .map(item => item[parentProp as keyof IFrame])
                .filter(obj => obj !== null && obj !== undefined)
                // Aqui precisamos fazer um cast para acessar a propriedade dinâmica
                .map(obj => (obj as any)[childProp])
            )
          );

          const filteredValues = uniqueValues.filter(
            (value): value is string | number => value !== null && value !== undefined
          );

          return { ...header, data: filteredValues };
        } else {
          // Para propriedades diretas (não aninhadas)
          const uniqueValues = Array.from(
            new Set(apiData.map(item => item[header.url as keyof IFrame]))
          );

          const filteredValues = uniqueValues.filter(
            (value): value is string | number => value !== null && value !== undefined
          );

          return { ...header, data: filteredValues };
        }
      }
      return header;
    });

    return updatedHeaderTable;
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {

      let url = `/frame?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      // Adicionar filtros à URL
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${value}`;
        }
      });
      const response = await axiosInstance.get(url);
      const dataResponse = response.data.data;
      if (dataResponse.length > 0) {
        const dataResponse = response.data.data;

        // Extrair os dados para os filtros
        const updatedHeaderTable = extractFilterData(dataResponse);

        // Atualiza o state com os novos dados de cabeçalho
        setHeaderTable(updatedHeaderTable as typeof headerTable);

        setFrame(dataResponse);
        setCurrentPage(response.data);
      } else {
        setFrame([]);
      }
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm, filters]);

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const handleCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
    barcode: string,
    code: string,
    brands: string | '',
    price: string,
  ) => {
    const isChecked = event.target.checked;
    toggleCheckbox(id);
    setTags(prevTags => {
      if (isChecked) {
        return [
          ...prevTags,
          {
            barcode,
            code,
            brands,
            price
          }
        ];
      } else {
        return prevTags.filter(tag => tag.barcode !== barcode);
      }
    });

  };

  const handleSelectAll = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const newSelectedIds = new Set(frame.map((item) => item.id));
      setSelectedIds(newSelectedIds);

      // Adiciona todos os itens às tags se ainda não estiverem presentes
      setTags(prevTags => {
        // Criar um mapa dos códigos existentes para evitar duplicatas
        const existingCodes = new Set(prevTags.map(tag => tag.code));

        // Filtrar apenas os itens que ainda não existem nas tags
        const newItems = frame.filter(item => !existingCodes.has(item.code))
          .map(item => ({
            barcode: item.barcode || '',
            code: item.code || '',
            brands: item.brands?.brand,
            price: item.price || ''
          }));

        // Retorne a combinação do array anterior com os novos itens
        return [...prevTags, ...newItems];
      });

    } else {
      CleanSelectIds();
      setTags([]);
    }
  };

  const exportData = async () => {
    startLoading();
    try {
      window.open('https://apioticamundial.clinicadeolhos.shop/frame-report', '_blank');
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  const handleSetPopMenuList = (filterType: string, value: any) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));

    // Adicione código para marcar o cabeçalho como tendo um filtro ativo
    setHeaderTable(prevHeaders =>
      prevHeaders.map(header =>
        header.api === filterType
          ? { ...header, activeFilter: value ? value : null }
          : header
      )
    );
  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <TitleMenu
        listPopButton={titlePopButtton}
        listPopMenu={titleListPopMenu}
        filterSearch={handleSearchChange}
        title="Registro de Armações"
        subtitle="Gerencie as armações do sistema"
        placeholderSearch="Código do produto"
        fetchData={fetchData}
        exportButton={exportData}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContaintableButton>
            <S.ContentButton>
              {selectedIds.length > 0 && (
                <TopActionBar
                  idSelecteds={selectedIds}
                  typeProduct="frame"
                  urlFilter={filters}
                  nameDeleteAll="frame-delete-multiple"
                  fetchData={fetchData}
                  handleDeleteResponse={handleDeleteResponse}
                  isTag={true}
                  itemsTag={tags}
                />
              )}
            </S.ContentButton>
            <S.Table>
              <S.THead>
                <tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {
                    headerTable.map((header, index) => (
                      <th key={index}>
                        {
                          header.filter ?
                            (
                              <FilterTable
                                name={header.name}
                                data={header.data || []}
                                setPopMenuList={(value) =>
                                  handleSetPopMenuList(header.api || '', value)
                                }
                                filterActive={!!header.activeFilter}
                              />
                            ) :
                            header.name
                        }
                      </th>
                    ))
                  }
                </tr>
              </S.THead>

              <S.TBody>
                {frame.length > 0 ? (
                  frame.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <S.CheckBox
                          onChange={(e) => handleCheckChange(
                            e,
                            val.id,
                            val.barcode,
                            val.code,
                            val.brands?.brand || '',
                            val.price
                          )}
                          type="checkbox"
                          id={val.code}
                          name={val.code}
                          checked={selectedIds.includes(val.id)}
                        />
                      </td>
                      <td>{index + 1 || "-"}</td>
                      <td>{val.code || "-"}</td>
                      <td>{val.size || "-"}</td>
                      <td>{val.bridge || "-"}</td>
                      <td>{val.haste || "-"}</td>
                      <td>{val.brands?.brand || "-"}</td>
                      <td>{val.materials?.material || "-"}</td>
                      <td>{val.color || "-"}</td>
                      <td>{val.amount || 0}</td>
                      <td>{CurrencyFormat(parseFloat(val.price || "0"))}</td>

                      <S.TdPopMenu>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                          </div>
                        )}
                      </S.TdPopMenu>
                    </tr>
                  ))
                ) : (
                  <NoData />
                )}
              </S.TBody>
            </S.Table>
          </S.ContaintableButton>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}

      <Update
        isOpenModal={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        updateList={fetchData}
      />

      <Details
        isOpenModalDetails={isOpenModal("details")}
        setModalClose={() => toggleModalVisibility("details")}
        selectedUrlId={openModalOptId}
      />

      <Delete
        updateList={fetchData}
        endpoint="frame"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container>
  );
}
